import { render } from "./PreLoader.vue?vue&type=template&id=29a77ab2&scoped=true"
import script from "./PreLoader.vue?vue&type=script&lang=js"
export * from "./PreLoader.vue?vue&type=script&lang=js"

import "./PreLoader.vue?vue&type=style&index=0&id=29a77ab2&scoped=true&lang=css"

import exportComponent from "E:\\_____LARAGON\\laragon\\www\\finalMatilda\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29a77ab2"]])

export default __exports__